import React from "react";
import KTScrolltop from "../../../_metronic/_assets/js/scrolltop";

/**
 * Created by gaslan on 3.4.2020
 */
export default class ScrollTop extends React.Component {
  scrollTopCommonRef = React.createRef();

  componentDidMount() {
    const scrollTopOptions = {
      offset: 300,
      speed: 600
    };
    // eslint-disable-next-line no-undef
    new KTScrolltop(this.scrollTopCommonRef.current, scrollTopOptions);
  }

    /**
     *
     * @return {*}
     */
  render() {
    return (
      <div
        id="kt_scrolltop"
        className="kt-scrolltop"
        ref={this.scrollTopCommonRef}
      >
        <i className="la la-arrow-up" />
      </div>
    );
  }
}
